/**
 * Single source of the photo bar's geometry (paire-app#129).
 *
 * `ImageNavigation` builds its sizes from these numbers, and the hero's
 * layout math (`pages/restaurant/components/hero/photoBar.ts`) and tests
 * derive their expectations from them, so the bar the member sees and the
 * arithmetic that keeps it clear of the Photos pill cannot drift apart.
 */

/** Arrow button box (Chakra `xs` icon button = 6 * 4px). */
export const ARROW_PX = 24;
/** Bar padding on every side (Chakra `1`). */
export const BAR_PADDING_PX = 4;
/** Gap between arrow / indicator / arrow in the `inline` layout (the hero). */
export const INLINE_GAP_PX = 8;
/** Gap in the `floating` layout (restaurant cards). */
export const FLOATING_GAP_PX = 12;
/** One pagination dot. */
export const DOT_PX = 8;
/** Gap between dots. */
export const DOT_GAP_PX = 8;
/** How far an arrow's invisible tap area extends beyond the button, horizontally (WCAG 2.5.5 44px target). */
export const ARROW_TAP_EXTENSION_X_PX = 10;

/** Vertical tap-area extension (above AND below) of the arrows in the `inline` layout: 24 + 10 + 10 = 44px. */
export const ARROW_TAP_EXTENSION_Y_PX = 10;
/** The hero's photo strip (bar + Photos pill) sits this far above the photo's bottom edge. Was 4px (jammed against the edge). */
export const PHOTO_STRIP_BOTTOM_PX = 16;
/** How much that moved the strip up versus the old 4px inset; the hero's title/stats block is lifted by the same amount so the clearance to the badges is unchanged. */
export const PHOTO_STRIP_LIFT_PX = PHOTO_STRIP_BOTTOM_PX - 4;

/** Width of a row of `count` dots. */
export function dotsWidthPx(count: number): number {
  return count * DOT_PX + Math.max(0, count - 1) * DOT_GAP_PX;
}

/** Width of the inline bar around an indicator of the given width (two arrows, two gaps, padding). */
export function inlineBarWidthPx(indicatorWidthPx: number): number {
  return 2 * BAR_PADDING_PX + 2 * ARROW_PX + 2 * INLINE_GAP_PX + indicatorWidthPx;
}
